import { render, staticRenderFns } from "./GsaEditor.vue?vue&type=template&id=2fc3f328&scoped=true&"
import script from "./GsaEditor.vue?vue&type=script&lang=js&"
export * from "./GsaEditor.vue?vue&type=script&lang=js&"
import style0 from "./GsaEditor.vue?vue&type=style&index=0&id=2fc3f328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3f328",
  null
  
)

export default component.exports